import React from 'react'
import { Link } from 'react-static'

import SectionTitle from 'components/Section-Title'
import ColorBar from 'components/Color-Bar'
import Map from 'components/Map'
import CompanyInfo from 'data/company-info'

const mapOptions = {
  isMarkerShown: true,
  zoom: 10
}

class Contact extends React.Component {
  render() {
    return (
      <React.Fragment>
        <ColorBar />

        <div id="contact" className="container container--grey">
          <SectionTitle
            icon="icon-contact.svg"
            title="Contact"
            titleClasses="section-title__copy--grey"
          />

          <div className="layout layout--content layout--content-wide layout--pb-lg">
            <div className="layout__item">
              <Link to={`http://maps.google.com/?q=${CompanyInfo.name},%20${CompanyInfo.address}`} className="contact-map" target="_blank">
                <Map options={mapOptions}></Map>
              </Link>

              <address>Glenbeigh Developments Ltd<br />
                Aberdeen House<br />
                South Road, Haywards Heath<br />
                Sussex, RH16 4NG</address>
            </div>
          </div>
        </div>
      </React.Fragment>
    )
  }
}

export default Contact;



// WEBPACK FOOTER //
// /Users/terrymasher/Development/glenbeigh-ltd/src/components/Contact.js